import type {
  Backend,
  LiteConversation,
  UnexpectedError,
} from "@superego/backend";
import type { ResultPromise } from "@superego/global-types";
import { makeSuccessfulResult } from "@superego/shared-utils";
import * as v from "valibot";
import UnexpectedAssistantError from "../../errors/UnexpectedAssistantError.js";
import makeConversation from "../../makers/makeConversation.js";
import * as structuralSchemas from "../../structural-schemas/index.js";
import BackendUsecase from "../../utils/BackendUsecase.js";
import ConversationUtils from "../../utils/ConversationUtils.js";
import CollectionsList from "../collections/List.js";

export default class AssistantsListConversations extends BackendUsecase<
  Backend["assistants"]["listConversations"]
> {
  argumentsSchema = v.tuple([]);
  resultSchema = structuralSchemas.global.result(
    v.array(structuralSchemas.backend.types.liteConversation()),
    [structuralSchemas.backend.errors.unexpectedError()],
  );

  async exec(): ResultPromise<LiteConversation[], UnexpectedError> {
    const conversations = await this.repos.conversation.findAll();

    const { data: collections } = await this.sub(CollectionsList).exec(false);
    if (!collections) {
      throw new UnexpectedAssistantError("Getting collections failed.");
    }
    const contextFingerprint =
      await ConversationUtils.getContextFingerprint(collections);

    return makeSuccessfulResult(
      conversations
        .map((conversation) =>
          makeConversation(conversation, contextFingerprint),
        )
        .map(({ messages, ...conversation }) => conversation),
    );
  }
}
